export function applyTheme(theme) {
  const root = document.documentElement;
  Object.keys(theme).forEach((cssVar) => {
    root.style.setProperty(cssVar, theme[cssVar]);
  });
}

export function createTheme({
  primary,
  secondary,
  headerPrimary,
  headerSecondary,
  textPrimary,
  textSecondary,
  secondary100,
  secondary200,
  secondary300,
  secondary400,
  secondary500,
  secondary600,
  secondary700,
  secondary800,
  secondary900,
  roundedNone,
  roundedSm,
  roundedRegular,
  roundedMd,
  roundedLg,
  roundedXl,
  rounded2xl,
  rounded3xl,
  roundedFull,
}) {
  return {
    "--theme-primary": primary,
    "--theme-secondary": secondary,
    "--theme-headerPrimary": headerPrimary,
    "--theme-headerSecondary": headerSecondary,
    "--theme-textPrimary": textPrimary,
    "--theme-textSecondary": textSecondary,
    "--theme-secondary100": secondary100,
    "--theme-secondary200": secondary200,
    "--theme-secondary300": secondary300,
    "--theme-secondary400": secondary400,
    "--theme-secondary500": secondary500,
    "--theme-secondary600": secondary600,
    "--theme-secondary700": secondary700,
    "--theme-secondary800": secondary800,
    "--theme-secondary900": secondary900,
    "--theme-roundedNone": roundedNone,
    "--theme-roundedSm": roundedSm,
    "--theme-roundedRegular": roundedRegular,
    "--theme-roundedMd": roundedMd,
    "--theme-roundedLg": roundedLg,
    "--theme-roundedXl": roundedXl,
    "--theme-rounded2xl": rounded2xl,
    "--theme-rounded3xl": rounded3xl,
    "--theme-roundedFull": roundedFull,
  };
}
